// compliance events
import showControlVarianceListEvent from '../../../../compliance/events/showControlVarianceList.event.compliance';

const openControlVarianceModal = () => () => {
  showControlVarianceListEvent.publish();
};

export default openControlVarianceModal;
